// extracted by mini-css-extract-plugin
export default {"root":"Header__root--2qmde","title":"Header__title--1LXd2","subTitle":"Header__subTitle--19RGc","hintIcon":"Header__hintIcon--1S3Xt"};